import Amplify from 'aws-amplify';

// const readScope = `${process.env.REACT_APP_COGNITO_API_RESOURCE}/read`;
// const writeScope = `${process.env.REACT_APP_COGNITO_API_RESOURCE}/write`;

export const setup = (awsconfig: any = {}) => {
  const config = {
    ...awsconfig,
    Auth: {
      userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
      userPoolWebClientId: process.env.REACT_APP_COGNITO_WEB_CLIENT_ID,
      region: process.env.REACT_APP_COGNITO_REGION,
      mandatorySignIn: true,
      ...awsconfig.Auth,
      oauth: {
        domain: process.env.REACT_APP_COGNITO_DOMAIN,
        redirectSignIn: `${window.location.protocol}//${window.location.host}/dashboard/`,
        redirectSignOut: `${window.location.protocol}//${window.location.host}/dashboard/`,
        responseType: 'code',
        scope: [
          'phone',
          'email',
          'profile',
          'openid',
          // 'aws.cognito.signin.user.admin',
          // readScope,
          // writeScope
        ],
        options: {
          AdvancedSecurityDataCollectionFlag: false
        }
      }
    }
  };

  return Amplify.configure(config);
};